/** @description Размер стрелок
 * EArrowsSize.LARGE Большие (полноэкранный режим)
 * EArrowsSize.NORMAL Обычные
 */
export var EArrowsSize = /*#__PURE__*/function (EArrowsSize) {
  EArrowsSize[EArrowsSize["LARGE"] = 0] = "LARGE";
  EArrowsSize[EArrowsSize["NORMAL"] = 1] = "NORMAL";
  return EArrowsSize;
}({});

/** @description Тип размера элемента
 * EWidthType.PIXEL Значение задано в пикселях
 * EWidthType.PERCENT Значение задано в процентах относительно элементов заданных этим же типом
 */
export var ESizeType = /*#__PURE__*/function (ESizeType) {
  ESizeType[ESizeType["PIXEL"] = 0] = "PIXEL";
  ESizeType[ESizeType["PERCENT"] = 1] = "PERCENT";
  return ESizeType;
}({});

/** @description Тип контрола карусели
 * EControlType.ARROWS Стрелки для переключения слайдов
 * EControlType.COUNTER Счетчик числа слайдов
 */
export var EControlType = /*#__PURE__*/function (EControlType) {
  EControlType[EControlType["ARROWS"] = 0] = "ARROWS";
  EControlType[EControlType["COUNTER"] = 1] = "COUNTER";
  return EControlType;
}({});

/** @description Интерфейс ширины элемента
 * @param {number} width Значение ширины элемента
 * @param {ESizeType} type Тип ширины элемента
 */

/** @description Интерфейс величины элемента
 * @param {number} width Значение величины элемента
 * @param {ESizeType} type Тип величины элемента
 */

/** @description Интерфейс с настройками ширины элементов
 * @param {IWidth} leftEar Настройки ширины левого уха
 * @param {IWidth} rightEar Настройки ширины правого уха
 * @param {IWidth} content Настройки ширины контента
 * @param {IWidth} gap Настройки ширины промежутка между слайдами
 */

/** @description Интерфейс с настройками карусели
 * @param {IElementsWidth} elementsWidth Настройки ширины элементов
 * @param {IElementSize} height Высота карусели
 * @param {number} slidesToShow Число слайдов одновременно видимых на экране
 * @param {number} slidesToScroll Число слайдов пролисытваемых одновременно
 * @param {IControl[]} defaultControls Дефолтные контролы, которые должны показываться в карусели
 * @param {IArrowsSettings} arrowsSettings Настройки стрелок
 */

/** @description Интерфейс с настройками карусели для определенного интервала ширины карусели
 * @param {number} minWidth Минимальная ширина карусели
 * @param {number} maxWidth Максимальная ширина карусели
 * @param {IMediaSettings} settings Настройки карусели при ширине в интервале [minWidth, maxWidth)
 */

/** @description Настройки карусели для серверного рендеринга
 * @param {IElementsWidth} elementsWidth Настройки ширины элементов
 * @param {number} height Высота карусели
 * @param {number} slidesToShow Число слайдов одновременно видимых на экране
 * @param {boolean} infinityScroll? Флаг для переключения конечной и бесконечной прокрутки в карусели
 */

/** @description Интерфейс контрола
 * @param {EControlType} type тип контрола
 */

/** @description Слайды для карусели
 * @param {React.ReactNode} node Содержимое слайда
 * @param {string} key Уникальный ключ
 */

/** @description Тип аргументов для коллбека смены файлов
 * @param {number} currentSlide Порядковый номер нового слайда
 * @param {number} prevSlide Порядковый номер предыдущего слайда
 * @param {number} totalSlides Общее количество слайдов
 */

/** @description Вычисленные значения ширин элементов в пикселях
 * @param {number} container Ширина контейнера
 * @param {number} content Ширина контента
 * @param {number} gap Ширина промежутка между слайдами
 * @param {number} leftEar Ширина левого уха
 * @param {number} rightEar Ширина правого уха
 * @param {number} slide Ширина слайда
 */

/** @description Вычисленные значения ширин элементов для серверного рендеринга
 * @param {string} container Ширина контейнера
 * @param {string} content Ширина контента
 * @param {string} gap Ширина промежутка между слайдами
 * @param {string} leftEar Ширина левого уха
 * @param {string} rightEar Ширина правого уха
 * @param {string} slide Ширина слайда
 */

/** @description Направление пролистывания карусели: -1 - влево, 1 - вправо
 */

/** @description стили для сервер сайд отрисовки карусели
 */

/** @description Позиция курсора
 */

/** @description Настройки стрелок
 * @param {EArrowsSize} size Размер стрелок
 * @param {boolean} alwaysVisible Видны ли всегда
 */